import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
	components: {},
})
export default class BadgeClient extends Vue {
	@Prop() readonly name
	@Prop() readonly cnpj
}
